import { Box, Button, ButtonGroup, Text } from "@chakra-ui/react";
import React from "react";
import { Field, Form } from "react-final-form";
import {
    AdaptedSelect,
    DropzoneControl,
    InputControl,
    Optional,
    TextareaControl
} from "../components/Form";
import { Loader } from "../components/Loader";
import { AccountRole, useAccountsQuery } from "../graphql";
import { getFullName } from "../utils";

interface ICreateMedicalFormValues {
  title: string;
  description: string;
  coverMediaKey: string;

  startDate: string;
  durationMinutes: number;
  maxParticipantsNumber: number;
  specialistId: number;
}

interface IEventForm {
  onSubmit: (values: ICreateMedicalFormValues) => void;
  initialValues?: Optional<ICreateMedicalFormValues>;
}

export const EventForm: React.FC<IEventForm> = ({
    onSubmit,
    initialValues
}) => {
    const validate = (values) => {
        const errors: { [key: string]: string } = {};

        if (!values.title) {
            errors.title = "Fushë e detyruar";
        }

        if (!values.description) {
            errors.description = "Fushë e detyruar";
        }

        if (!values?.cover?.key) {
            errors.cover = "Fushë e detyruar";
        }

        if (!values.startDate) {
            errors.startDate = "Fushë e detyruar";
        }

        if (!values.durationMinutes) {
            errors.durationMinutes = "Fushë e detyruar";
        }

        if (!values.maxParticipantsNumber) {
            errors.maxParticipantsNumber = "Fushë e detyruar";
        }

        if (!values.specialistId) {
            errors.specialistId = "Fushë e detyruar";
        }

        return errors;
    };

    const { loading, data } = useAccountsQuery({
        variables: {
            role: AccountRole.Doctor,
            page: 1,
            pageLimit: 1000
        }
    });

    const accounts = data?.accounts.nodes;

    if (loading) {
        return <Loader></Loader>;
    }

    return (
        <Form
            onSubmit={ onSubmit }
            validate={ validate }
            // initialValues={initialValues}
            render={ ({
                handleSubmit,
                form,
                errors,
                submitting,
                pristine,
                values
            }) => (
                <Box as="form" p={ 2 } onSubmit={ handleSubmit }>
                    <Field name="specialistId" component={ AdaptedSelect } label="Mjeku">
                        { accounts.map((account) => (
                            <option value={ account.id }>{ getFullName(account) }</option>
                        )) }
                    </Field>
                    <TextareaControl name="title" label="Titulli" />
                    <TextareaControl name="description" label="Përshkrimi" />
                    <DropzoneControl name="cover" label="Kopertina" />
                    <InputControl type="datetime-local" name="startDate" label="Data" />
                    <Field
                        name="durationMinutes"
                        component={ AdaptedSelect }
                        label="Kohëzgjatja"
                    >
                        <option value="60">60 minuta</option>
                        <option value="90">90 minuta</option>
                        <option value="120">120 minuta</option>
                        <option value="150">150 minuta</option>
                    </Field>
                    <Field
                        name="maxParticipantsNumber"
                        component={ AdaptedSelect }
                        label="Pjesëmarrja maksimaple"
                    >
                        <option value="25">25 persona</option>
                        <option value="50">50 persona</option>
                        <option value="75">75 persona</option>
                        <option value="100">100 persona</option>
                        <option value="125">125 persona</option>
                        <option value="150">150 persona</option>
                    </Field>{ " " }
                    <ButtonGroup spacing={ 4 }>
                        <Button
                            isLoading={ submitting }
                            loadingText="Duke dërguar"
                            variantColor="teal"
                            type="submit"
                        >
                            Ruaj
                        </Button>
                        <Button
                            variantColor="teal"
                            variant="outline"
                            onClick={ form.reset }
                            isDisabled={ submitting || pristine }
                        >
                            Pastro
                        </Button>
                    </ButtonGroup>
                </Box>
            ) }
        />
    );
};
